import styled from 'styled-components'

import animationSuccess from 'shared/assets/images/animationSuccess.gif'
import { useIntl } from 'react-intl'
import React from 'react'
import { H6, Text } from 'app/common/typography'
import { SIZE, SPACING } from 'app-v2/design-tokens'
import { Spacer, PrimaryButton } from 'app-v2/design-systems'
import { AlertModal } from 'app/common/modals'

type SuccessStudentProfileModalProps = {
    onConfirm: () => void,
    onClose: () => void
}
export const SuccessStudentProfileModal = ({
    onConfirm,
    onClose
}: SuccessStudentProfileModalProps) => {
    const intl = useIntl()

    return (
        <AlertModal isOpen handleClose={onClose}>
            <StyledContainer>
                <StyledImage src={animationSuccess} />

                <H6>
                    {intl.formatMessage({
                        id: 'kingdom.profile.form.student.success'
                    })}
                </H6>

                <Spacer />

                <StyledText>
                    {intl.formatMessage({
                        id: 'kingdom.profile.form.student.success.infos'
                    })}
                </StyledText>

                <Spacer size={SIZE.XL} />

                <PrimaryButton onClick={onConfirm} fullLength>
                    {intl.formatMessage({
                        id: 'kingdom.profile.form.student.success.cta'
                    })}
                </PrimaryButton>
            </StyledContainer>
        </AlertModal>
    )
}

const StyledImage = styled.img`
    width: 200px;
    height: 200px;
`

const StyledText = styled(Text)`
    text-align: center;
`
const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0 ${SPACING.XL};
    padding-top: 0;
    align-items: center;
    text-align: center;
`
